/*
|-----------------------------------------
| Tabs
|-----------------------------------------
| Simple tabs.
|
*/
document.querySelectorAll('a.tab-click').forEach(tab => {
  tab.addEventListener('click', function (event) {
    event.preventDefault();
    var $this = event.target;
    var targetId = $this.getAttribute('href');
    document.querySelectorAll('.tabs > li, .tabs > div').forEach(t => {
      t.classList.remove('active');
    });
    $this.parentElement.classList.add('active');
    document.querySelectorAll('div.tab').forEach(t => {
      t.classList.add('hide');
    });
    document.querySelector(targetId).classList.remove('hide');
  });
});

/*
|-----------------------------------------
| Tabbed Products
|-----------------------------------------
| Tabbed products section, used on the homepage.
|
*/
var productsTabs = document.querySelectorAll('.js--home-products-tab');
productsTabs.forEach(function (tab) {
  tab.addEventListener('click', function (event) {
    event.preventDefault();
    var $this = event.target;
    var section = $this.closest('section');
    var productSection = section.nextElementSibling;
    var $id = tab.getAttribute('href');
    section.querySelectorAll('.js--home-products-tab').forEach(function (t) {
      var $parent = t.parentElement;
      $parent.classList.remove('bold', 'purple', 'active');
    });
    $this.parentElement.classList.add('bold', 'purple', 'active');
    if (productSection != null) {
      productSection.querySelectorAll('.js--home-products-content').forEach(function (content) {
        content.style.display = "none";
      });
    } else {
      section.querySelectorAll('.js--home-products-content').forEach(function (content) {
        content.style.display = "none";
      });
    }
    document.querySelector($id).style.display = 'block';
  });
});

/*
|-----------------------------------------
| Validate Form
|-----------------------------------------
| Checks for required fields before submitting.
| This function is use for the contact forms.
|
| @param btn = this
|
*/
var validateForm = function (btn) {
  var validationSuccess = true;
  var $form = btn.closest('form');

  // Reset all error messages and textbox styling
  $form.querySelectorAll('.error-message').forEach(function (el) {
    el.remove();
  });

  // Check all required text fields.
  $form.querySelectorAll('input:required, textarea:required, select:required').forEach(function (el) {
    let $parent = el.parentElement;
    let $parentContainer = $parent.parentElement;
    let inputLabel = ($parent.querySelector('label') != null) ? $parent.querySelector('label').textContent : "";
    let valueLength = el.value.length;
    let minLength = 0;

    if (el.getAttribute('minlength') != undefined && el.getAttribute('minlength') != false) {
      minLength = parseInt(el.getAttribute('minlength'));
    }

    // Check a value has been entered
    if (el.value == '' || valueLength < minLength) {
      validationSuccess = false;
      $parent.classList.add('error');
      if (valueLength < minLength && el.value != '') {
        $parent.insertAdjacentHTML('beforeend', '<p class="small magenta error-message">' + inputLabel + ' should be ' + minLength + ' characters or more.</p>');
      }
    }

    // Check for a valid email
    if (el.getAttribute('type') == "email" && el.value != '') {
      var pattern = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      if ((el.value.trim()).match(pattern) == null) {
        validation = false;
        $parent.classList.add('error');
        $parent.insertAdjacentHTML('beforeend', '<p class="small magenta error-message">Please enter a valid email address.</p>');
      }
    }
  });

  return validationSuccess;
}
